const ENTRY_FIELDS = ["description", "deadline", "responsible_user_id"];

export function indexMeetingEntries(meeting) {
  const map = new Map();
  for (const group of meeting?.groups || []) {
    for (const entry of group.entries || []) map.set(entry.id, entry);
  }
  return map;
}

function keepsDraft(keys, entryId) {
  return ENTRY_FIELDS.some((field) => keys.has(`${entryId}:${field}`));
}

// Remote agenda replaces the meeting. Fields this user is editing stay put.
export function mergeMeetingAgenda(current, fresh, draftKeys = new Set()) {
  if (!fresh) return current;
  const keys = draftKeys instanceof Set ? draftKeys : new Set(draftKeys || []);
  if (!current?.groups || keys.size === 0) return fresh;

  const localById = new Map();
  for (const group of current.groups || []) {
    for (const entry of group.entries || []) localById.set(entry.id, entry);
  }

  const seen = new Set();
  const groups = (fresh.groups || []).map((group) => ({
    ...group,
    entries: (group.entries || []).map((entry) => {
      seen.add(entry.id);
      const local = localById.get(entry.id);
      if (!local) return entry;
      const next = { ...entry };
      if (keys.has(`${entry.id}:description`)) next.description = local.description;
      if (keys.has(`${entry.id}:deadline`)) next.deadline = local.deadline;
      if (keys.has(`${entry.id}:responsible_user_id`)) {
        next.responsible_user_id = local.responsible_user_id;
        next.responsible_user = local.responsible_user;
      }
      return next;
    }),
  }));

  for (const group of current.groups || []) {
    const kept = (group.entries || []).filter((entry) => !seen.has(entry.id) && keepsDraft(keys, entry.id));
    if (!kept.length) continue;
    const target = groups.find((row) => row.id === group.id);
    if (target) target.entries = [...target.entries, ...kept];
    else groups.push({ ...group, entries: kept });
  }

  return { ...fresh, groups };
}
